/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：MrMw
 */

"use strict"

/* harmony export (immutable) */
/* harmony import */
export { update_state }
import * as __WEBPACK_IMPORTED_MODULE_0_lodash_assign__ from /* BUAs */"lodash/assign"
/* harmony import */
import __WEBPACK_IMPORTED_MODULE_0_lodash_assign___default from /* BUAs */"lodash/assign"
function update_state(old_value, new_value) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash_assign___default({}, old_value, new_value)
}

/***/
